const FORM_WIDTH = 400; // Form width in pixels

export { FORM_WIDTH };
